let el = document.querySelector('h1'); // Change selector as needed
el.innerHTML = el.innerHTML.replace(/&nbsp;/g, ' ');
